module.exports = __webpack_public_path__ + "static/monei_pay_1_es-63d6fcbc31e9569b6d31fba0cbe89b0a.png";